import { render, staticRenderFns } from "./equip_attr_temp.vue?vue&type=template&id=5bc4ec6f&scoped=true"
import script from "./equip_attr_temp.vue?vue&type=script&lang=js"
export * from "./equip_attr_temp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4ec6f",
  null
  
)

export default component.exports